export const FETCHING_ANTICIPATED_INVOICE_VEHICLES_LIST = '@@toyota/FETCHING_ANTICIPATED_INVOICE_VEHICLES_LIST';
export const FETCHED_ANTICIPATED_INVOICE_VEHICLES_LIST = '@@toyota/FETCHED_ANTICIPATED_INVOICE_VEHICLES_LIST';
export const FETCHED_ANTICIPATED_INVOICE_VEHICLES_LIST_FAILED = '@@toyota/FETCHED_ANTICIPATED_INVOICE_VEHICLES_FAILED';

export const SAVING_ANTICIPATED_INVOICE_VEHICLES_LIST = '@@toyota/SAVING_ANTICIPATED_INVOICE_VEHICLES_LIST';
export const SAVED_ANTICIPATED_INVOICE_VEHICLES_LIST = '@@toyota/SAVED_ANTICIPATED_INVOICE_VEHICLES_LIST';
export const SAVED_ANTICIPATED_INVOICE_VEHICLES_LIST_FAILED = '@@toyota/SAVED_ANTICIPATED_INVOICE_VEHICLES_LIST_FAILED';

export const FETCHING_VEHICLES_VALIDATION_LIST = '@@toyota/FETCHING_VEHICLES_VALIDATION_LIST';
export const FETCHED_VEHICLES_VALIDATION_LIST = '@@toyota/FETCHED_VEHICLES_VALIDATION_LIST';
export const FETCHED_VEHICLES_VALIDATION_LIST_FAILED = '@@toyota/FETCHED_VEHICLES_VALIDATION_LIST_FAILED';

export const SENDING_VEHICLES_VALIDATION_NOTIFICATION = '@@toyota/SENDING_VEHICLES_VALIDATION_NOTIFICATION';
export const SENDED_VEHICLES_VALIDATION_NOTIFICATION = '@@toyota/SENDED_VEHICLES_VALIDATION_NOTIFICATION';
export const SENDED_VEHICLES_VALIDATION_NOTIFICATION_FAILED = '@@toyota/SENDED_VEHICLES_VALIDATION_NOTIFICATION_FAILED';

export const NOTIFICATING_ANTICIPATED_INVOICE_VEHICLES_LIST = '@@toyota/NOTIFICATING_ANTICIPATED_INVOICE_VEHICLES_LIST';
export const NOTIFICATED_ANTICIPATED_INVOICE_VEHICLES_LIST = '@@toyota/NOTIFICATED_ANTICIPATED_INVOICE_VEHICLES_LIST';
export const NOTIFICATED_ANTICIPATED_INVOICE_VEHICLES_LIST_FAILED =
  '@@toyota/NOTIFICATED_ANTICIPATED_INVOICE_VEHICLES_LIST_FAILED';

export const SENDING_VEHICLES_ACC_TRANSFER = '@@toyota/SENDING_VEHICLES_ACC_TRANSFER';
export const SENDED_VEHICLES_ACC_TRANSFER = '@@toyota/SENDED_VEHICLES_ACC_TRANSFER';
export const SENDED_VEHICLES_ACC_TRANSFER_FAILED = '@@toyota/SENDED_VEHICLES_ACC_TRANSFER_FAILED';
  
export const RESTORE_TASKS_VALIDATION_VALUE = '@@toyota/RESTORE_TASKS_VALIDATION_VALUE';

